import { create } from "zustand";
import { persist } from "zustand/middleware";
import api from "../utils/api";
import { clearKeys } from "../utils/crypto";

const useAuthStore = create(
  persist(
    (set, get) => ({
      user: null,
      token: null,
      isLoading: false,

      register: async (data) => {
        set({ isLoading: true });
        try {
          const res = await api.post("/auth/register", data);
          set({ isLoading: false });
          set({ user: res.data.user, token: res.data.token });
          return { success: true };
        } catch (err) {
          set({ isLoading: false });
          return {
            success: false,
            message: err.response?.data?.message || "Registration failed",
          };
        }
      },

      login: async (data) => {
        set({ isLoading: true });
        try {
          const res = await api.post("/auth/login", data);
          set({ isLoading: false });
          if (res.data.requiresVerification) {
            return {
              success: true,
              requiresVerification: true,
              email: res.data.email,
              devOtp: res.data.devOtp,
            };
          }
          if (res.data.requires2FA) {
            return {
              success: true,
              requires2FA: true,
              email: res.data.email,
              devOtp: res.data.devOtp,
            };
          }
          set({ user: res.data.user, token: res.data.token });
          return { success: true };
        } catch (err) {
          set({ isLoading: false });
          return {
            success: false,
            message: err.response?.data?.message || "Login failed",
          };
        }
      },

      logout: async () => {
        try {
          await api.post("/auth/logout");
        } catch (_) {}
        clearKeys();
        // Reset chat store
        try {
          const { default: useChatStore } = await import("./chatStore");
          useChatStore.getState().resetStore();
        } catch (_) {}
        set({ user: null, token: null });
      },

      updateUser: (user) => set({ user }),

      refreshUser: async () => {
        try {
          const res = await api.get("/auth/me");
          set({ user: res.data.user });
        } catch (_) {
          set({ user: null, token: null });
        }
      },
    }),
    {
      name: "chatify-auth",
      partialize: (state) => ({ user: state.user, token: state.token }),
    }
  )
);

export default useAuthStore;
